<div
  class="bottom-page-panel position-absolute bottom-7 end-5 z-3 shadow-sm rounded-2 d-flex gap-2 align-items-center"
>
  <ng-content></ng-content>
</div>
